import React from 'react';
import { TreeItem } from '../TreeItem';

const TreeList = React.memo(props => {
    const { data, flattenClauseGroups, noIndentation } = props;

    return data.map(option => (
        <TreeItem
            key={option.id}
            flattenClauseGroups={flattenClauseGroups}
            option={option}
            noIndentation={noIndentation}
        />
    ));
});

export default TreeList;
